// Офлайн-режим (public/sw.js): регистрация service worker при запуске и «Сохранить для офлайна» —
// страница тура, данные тура и карточки для таксиста кэшируются заранее, чтобы открыться в роуминге без интернета.

const supported = (): boolean => typeof navigator !== 'undefined' && 'serviceWorker' in navigator;

/** Зарегистрировать service worker (после загрузки страницы, чтобы не мешать первому экрану) */
export function registerOffline(): void {
  if (!supported()) return;
  const run = () => { navigator.serviceWorker.register('/sw.js').catch(() => { /* нет https или запрещено */ }); };
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
}

/** Сохранить адреса для офлайна; число сохранённых (0 — нет service worker или сети) */
export async function saveOffline(urls: string[]): Promise<number> {
  if (!supported()) return 0;
  const reg = await Promise.race([
    navigator.serviceWorker.ready,
    new Promise<null>((r) => setTimeout(() => r(null), 5000)),
  ]);
  const sw = reg?.active;
  if (!sw) return 0;
  return new Promise<number>((resolve) => {
    const ch = new MessageChannel();
    const timer = setTimeout(() => resolve(0), 30000);
    ch.port1.onmessage = (e: MessageEvent<{ saved?: number }>) => { clearTimeout(timer); resolve(Number(e.data?.saved) || 0); };
    sw.postMessage({ type: 'cache-urls', urls }, [ch.port2]);
  });
}

/** Есть ли сеть сейчас */
export const isOnline = (): boolean => typeof navigator === 'undefined' || navigator.onLine !== false;
